module.exports = __webpack_public_path__ + "img/dumpattenuator_driving.8becd020.svg";